export default __webpack_public_path__ + "static/media/loadingLogo.4d834f75.svg";